import { makeStyles, Tooltip } from "material-ui-core";
import {
  Badge,
  formatTypeLabel,
  IconOrInitials,
  parseTypeList,
} from "../DataControlUtils";
import { renderDateTime } from "../../../components/views/Util/ViewCommon";
import { DataGrid, GridOverlay } from "@mui/x-data-grid";
import { isNull } from "lodash";
import { getVariantColor, getVariantValue } from "./DataControlRiskTable";
import { scope } from "../DataControlConstans";


const useTooltipStyles = makeStyles(() => ({
  tooltip: {
    backgroundColor: "#fff",
    color: "#000",
    fontSize: "13px",
    whiteSpace: "pre-wrap",
    maxWidth: 220,
    padding: "8px 12px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
    border: "1px solid #e0e0e0",
  },
  arrow: {
    color: "#fff",
    "&::before": {
      border: "1px solid #e0e0e0",
    },
  },
}));

export function RiskLogTable({ categoryId, auditTrail, loading, isUserRisk }) {
  const tooltipClasses = useTooltipStyles();
  const columns = [
    {
      field: "timestamp",
      headerName: "Date",
      flex: 1,
      renderCell: ({ value }) => <span>{renderDateTime(value)}</span>,
    },
    {
      field: "action",
      headerName: "Action",
      flex: isUserRisk ? 1.8 : 1.8,
      renderCell: ({ value }) => <Badge variant="green">{value}</Badge>,
    },
    {
      field: "actionTakenBy",
      headerName: "Action Taken By",
      flex: 1.8,
      renderCell: ({ value }) => <span style={{overflow: "hidden", textOverflow: "ellipsis"}} title={value}>{value || "-"}</span>,
    },
    ...(categoryId !== "location"
      ? [
          {
            field: "fileName",
            headerName: "File",
            flex: 1.4,
          },
        ]
      : []),
    {
      field: "source",
      headerName: "Source",
      flex: 0.7,
      minWidth: 120,
    },
    {
      field: "scope",
      headerName: "Scope",
      flex: 0.7,
      minWidth: 100,
      renderCell: ({ value }) => (
        <span className="fsc-badge fsc-badge--purple">{scope[value]}</span>
      ),
    },
    {
      field: "status",
      headerName: "Status",
      flex: 0.7,
      minWidth: 120,
      renderCell: ({ value, row }) => (
        <Tooltip
          classes={tooltipClasses}
          title={
            row.reason ? (
              <span style={{ whiteSpace: "pre-wrap", display: "block" }}>
                {row.reason}
              </span>
            ) : (
              ""
            )
          }
          arrow
          placement="top"
          PopperProps={{
            modifiers: {
              preventOverflow: { enabled: true, boundariesElement: "viewport" },
            },
          }}
        >
          <span style={{ display: "inline-block" }}>
            <Badge variant={getVariantColor[value.toUpperCase()]}>
              {isNull(value) ? "Pending" : getVariantValue[value.toUpperCase()]}
            </Badge>
          </span>
        </Tooltip>
      ),
    },
  ];

  return (
    <div
      style={{
        height: 450,
        width: "100%",
      }}
    >
      <DataGrid
        rows={auditTrail?.rows ?? []}
        columns={columns}
        pagination
        paginationMode="client"
        pageSizeOptions={[10, 20, 50, 100]}
        initialState={{
          pagination: {
            paginationModel: {
              page: auditTrail?.page ?? 0,
              pageSize: auditTrail?.pageSize ?? 10,
            },
          },
        }}
        disableRowSelectionOnClick
        disableColumnMenu
        slots={{
          noRowsOverlay: () => (
            <GridOverlay>No audit history found</GridOverlay>
          ),
        }}
      />
    </div>
  );
}